export function getScrollParent(node: HTMLElement | null) {
	if (node == null) {
		return null;
	}
	if (node.scrollHeight > node.clientHeight) {
		return node;
	} else {
		return getScrollParent(node.parentElement);
	}
}
